import { Form, useFormikContext } from 'formik'
import { Button } from '@mui/material'

import { UsersSearchInput } from '../account/account-users/invite-modal/user-search-input.component'
import { IAccountScannerCreateForm } from 'src/types'

import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

export const InviteForm = () => {
  const classes = useStyles()
  const { errors, dirty, isSubmitting } = useFormikContext<IAccountScannerCreateForm>()

  const submitDisabled = !dirty || !!Object.keys(errors).length || isSubmitting
  return (
    <Form className={classes.form}>
      <div className={classes.inputsWrapper}>
        <UsersSearchInput />
      </div>
      <Button disabled={submitDisabled} type="submit">
        <HelperWrapper t="invite-scanner-modal-title" />
      </Button>
    </Form>
  )
}
